import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'validation' })
export class Validation implements PipeTransform {
  constructor() {}
  transform(validation) {
      switch(validation){
          case -2:
              return "Type de fichier non reconnu";
          case 0:
              return "Non validé";
          case 1:
              return "Validé";  
      }
  }
} 